import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { IFirstStepComplete, ISelectedChargeInfo } from 'src/app/card-operations/models/paymenType.model';
import { AppConfig } from 'src/app/config-service/app.config';
import { IOnlineChargeMediator, OnlineChargeBaseComponent, OnlineChargeMediator } from '../utility-classes/online-charge-classes';

@Component({
  selector: 'app-second-step',
  templateUrl: './second-step.component.html',
  styleUrls: ['./second-step.component.scss', '../../../card-operations.component.css']
})
export class SecondStepComponent extends OnlineChargeBaseComponent implements OnInit {
  @Input() viewParams!:IFirstStepComplete;
  @Input() concreteMediator!: IOnlineChargeMediator;

  apiSettings = AppConfig.settings;
  isChargeForm1Checked = false;
  isChargeForm2Checked = false;
  public urlSafe!: SafeResourceUrl;
  public activeFormInView = '';

  public showFormIframe = false;

  constructor(
    public translate: TranslateService,
    private toastr: ToastrService,
    private sanitizer: DomSanitizer,
    protected mediator: OnlineChargeMediator
  ) {
    super(mediator);
  }

  ngOnInit(): void {
    this.setMediator(this.concreteMediator);
  }

  onlineCharge_onTermsAndConditionChanged(value:any) {
    if (value === 'form1') {
      this.isChargeForm1Checked = !this.isChargeForm1Checked;
    }

    if (value === 'form2') {
      this.isChargeForm2Checked = !this.isChargeForm2Checked;
    }
  }

  onlineCharge_onChargeDetailClick = () => {
    if (this.isChargeForm1Checked && this.isChargeForm2Checked) {
      this.mediator.notifyOnlineCharge(this, 'TERMS_AGREED');
      //this.modalState = 'ccEntry';
    } else {
      this.toastr.error(
        this.translate.instant('CARDOPERATIONS_CHARGE_DETAIL_FORM_ERROR')
      );
    }
  };

  getPreliminaryFormUrl = () => {
    return (
      this.apiSettings.documents.ONLINE_CHARGE_TEKLI_DOLUM_ON_BILGILENDIRME +
      this.translate.currentLang +
      '.html'
    );
  };

  getTermsAndConditionsFormUrl = () => {
    return (
      this.apiSettings.documents.ONLINE_CHARGE_TEKLI_DOLUM_SOZLESME +
      this.translate.currentLang +
      '.html'
    );
  };

  setActiveFormInView(value:any) {
    this.showFormIframe = !this.showFormIframe;

    if (value === 'form1') {
      this.activeFormInView =
        this.apiSettings.documents.ONLINE_CHARGE_TEKLI_DOLUM_ON_BILGILENDIRME +
        this.translate.currentLang +
        '.html';
    }

    if (value === 'form2') {
      this.activeFormInView =
        this.apiSettings.documents.ONLINE_CHARGE_TEKLI_DOLUM_SOZLESME +
        this.translate.currentLang +
        '.html';
    }
    //this.sanitizer.bypassSecurityTrustResourceUrl(this.activeFormInView)
    //this.sanitizer.bypassSecurityTrustResourceUrl(this.activeFormInView);
    this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(
      this.activeFormInView
    );
    // this.sanitizer.sanitize(SecurityContext.URL, this.activeFormInView);
  }

  unsetActiveFormInView() {
    this.showFormIframe = !this.showFormIframe;
    this.activeFormInView = '';
    this.urlSafe = '';
  }

}